import React, { useEffect, useState } from "react";
import "./cssabout.css";
import MOI from "../../assets/templates/moi.jpg";
import { GiGiftOfKnowledge } from "react-icons/gi";
import { FaUsers, FaAward } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { baseURL } from "../../App";
import i18n from "../../i18n/config";

import SkeletonLoader from "../Skeleton/SkeletonLoader";

const About = () => {
  const { t } = useTranslation();
  const [aboutData, setAboutData] = useState(null);
  const API_URL = `${baseURL}/api/about`;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        const response = await axios.get(API_URL);
        setAboutData(response.data[response.data.length - 1]);
      } catch (error) {
        setError("Error fetching about data");
        console.error("Error fetching about data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAboutData();
  }, [API_URL]);

  if (loading) {
    return (
      <section id="about">
        <h5>{t("about.sub_title")}</h5>
        <h2>{t("about.title")}</h2>
        <SkeletonLoader type="card" />
      </section>
    );
  }
  if (error) return <p>{error}</p>;

  return (
    <section id="about">
      <h5>{t("about.sub_title")}</h5>
      <h2>{t("about.title")}</h2>
      <div className="container about_container">
        <div className="about_me">
          <div className="about_me-img">
            <img src={aboutData?.image || MOI} alt="Me" />
          </div>
        </div>

        <div className="about_content">
          <div className="about_cards">
            <article className="about_card item_scale">
              <FaAward className="about_icon" />
              <h5>{t("about.client")}</h5>
              <small>{aboutData?.clients}+</small>
            </article>

            <article className="about_card item_scale">
              <FaUsers className="about_icon" />
              <h5>{t("about.project")}</h5>
              <small>
                {aboutData?.projects}+ {t("about.complete")}
              </small>
            </article>

            <article className="about_card item_scale">
              <GiGiftOfKnowledge className="about_icon" />
              <h5>{t("about.work_experience")}</h5>
              <small>
                {aboutData?.workExperience}+ {t("years.title")}
                {/* {aboutData?.workExperience}+ {t("months.title")} {t("about.intern")} */}
              </small>
            </article>
          </div>
          <p>
            {/* <Trans i18nKey="about.current_status">
              <i></i>
              <i></i>
              <i></i>
              <i></i>
              <i></i>
              {aboutData.currentStatus || t("about.current_status")}
            </Trans> */}
            <p>
              {i18n.language === "en" ? aboutData?.description?.en : aboutData?.description?.fr}
            </p>
            {/* <p>{aboutData?.description || t("about.default_description")}</p> */}
            <strong>{aboutData?.identity}</strong>
            {/* <strong>{aboutData.identity || t("identity")}</strong> */}
          </p>
          <a href="#contact" className="btn btnPrimary">
            {t("writeToMe")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
